import React from 'react';
import { Box } from '@chakra-ui/react';

type CounterProps = { count: number };

// eslint-disable-next-line react/prop-types
const Counter: React.FC<CounterProps> = ({ count }) => {
  // TODO: Apply firebase hook.
  return (
    <Box
      mt={5}
      p={1}
      paddingLeft={5}
      paddingRight={5}
      borderRadius={10}
      background={'white'}
      color={'gray.500'}
      textAlign={'center'}
    >
      지금까지 {count}번 추천드렸어요.
    </Box>
  );
};

export default Counter;
